import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { GlobalStyles } from '@styles/GlobalStyles';
import { AudioProvider } from '@context/AudioContext';
import { ThemeProvider, StyleSheetManager } from 'styled-components';
import { theme } from '@styles/theme';
import { CartProvider } from '@context/CartContext';
import { HelmetProvider } from 'react-helmet-async';

// Function to determine whether to forward props (filter transient props starting with $)
const shouldForwardProp = (prop: string) => !prop.startsWith('$');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <StyleSheetManager shouldForwardProp={shouldForwardProp}>
          <ThemeProvider theme={theme}>
            <CartProvider>
              <AudioProvider>
                <GlobalStyles />
                <App />
              </AudioProvider>
            </CartProvider>
          </ThemeProvider>
        </StyleSheetManager>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);